import React from 'react';

import { useIntl } from 'react-intl-next';

import { Stack, Text } from '@atlaskit/primitives/compiled';
import { TabPanel } from '@atlaskit/tabs';

import { PluginInvocationItem } from '../debug-items/plugin-invocation';
import { messages } from '../messages';
import type { PluginInvocation } from '../types';

import { Panel } from './panel-wrapper';

type PluginInvocationsPanelProps = {
	nonSearchPluginInvocations: PluginInvocation[];
};

export const PluginInvocationsPanel = ({
	nonSearchPluginInvocations,
}: PluginInvocationsPanelProps) => {
	const { formatMessage } = useIntl();

	return (
		<TabPanel>
			<Panel testId="sain-online-debugger-plugin-invocations-panel">
				{nonSearchPluginInvocations.length > 0 ? (
					<Stack space="space.0">
						{nonSearchPluginInvocations.map((plugin, index) => (
							<PluginInvocationItem
								key={plugin.plugin_invocation_id || index}
								plugin={plugin}
								index={index}
							/>
						))}
					</Stack>
				) : (
					<Text>{formatMessage(messages.ai_debugger_modal_no_plugins_invoked)}</Text>
				)}
			</Panel>
		</TabPanel>
	);
};
